import { useEffect } from "react";

export default function Seo({ title, description, path }) {
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && path) canonical.setAttribute("href", `https://www.w8ed.com${path}`);
  }, [title, description, path]);
  return null;
}
